import clsx from 'clsx';
import {
  flattenConnection,
  Money,
  ShopifyAnalyticsProduct,
  useMoney,
} from '@shopify/hydrogen';
import {Text, Link, AddToCartButton} from '~/components';
import {isDiscounted, isNewArrival} from '~/lib/utils';
import {getProductPlaceholder} from '~/lib/placeholders';
import type {MoneyV2, Product} from '@shopify/hydrogen/storefront-api-types';
import {defaultImage, getProductImage} from '~/utils';
import * as _ from 'lodash';

export function ProductCard({
  product,
  label,
  loading,
  onClick,
}: // quickAdd,
{
  product: Product;
  label?: string;
  className?: string;
  loading?: HTMLImageElement['loading'];
  onClick?: () => void;
  quickAdd?: boolean;
}) {
  const quickAdd = false;
  let cardLabel;
  const images = getProductImage(product);
  const cardProduct: Product = product?.variants
    ? (product as Product)
    : getProductPlaceholder();
  if (!cardProduct?.variants?.nodes?.length) return null;

  const firstVariant = flattenConnection(cardProduct.variants)[0];

  if (!firstVariant) return null;
  const {image, price, compareAtPrice} = firstVariant;
  let _image = {};
  if (images.length !== 0) {
    images.push(_.get(image, 'url', ''));
    _image = {
      url: images[0],
      altText: '',
      width: 860,
      height: 700, // @ts-ignore
    } as any;
  }

  if (label) {
    cardLabel = label;
  } else if (isDiscounted(price as MoneyV2, compareAtPrice as MoneyV2)) {
    cardLabel = 'Sale';
  } else if (isNewArrival(product.publishedAt)) {
    cardLabel = 'New';
  }

  const productAnalytics: ShopifyAnalyticsProduct = {
    productGid: product.id,
    variantGid: firstVariant.id,
    name: product.title,
    variantName: firstVariant.title,
    brand: product.vendor,
    price: firstVariant.price.amount,
    quantity: 1,
  };

  return (
    <div className="col-lg-3 col-md-6 col-sm-6" key={product.id}>
      <Link
        onClick={onClick}
        to={`/products/${product.handle}`}
        prefetch="intent"
        className={'w-100 product-card'}
      >
        <div className="single-products">
          <div className="products-image">
            <img
              src={_.get(_image, 'url', defaultImage(product.title))}
              alt={product.title}
            />
          </div>
          <div className="products-content">
            <Text
              className="w-full overflow-hidden whitespace-nowrap text-ellipsis "
              as="h3"
            >
              {_.truncate(product.title, {
                length: 26,
                omission: '...',
              })}
            </Text>
            {quickAdd ? (
              <div className=" gap-4">
                <span className="diplay-flex center justify-center">
                  <Money withoutTrailingZeros data={price!} />
                  &nbsp;
                  {isDiscounted(
                    price as MoneyV2,
                    compareAtPrice as MoneyV2,
                  ) && (
                    <CompareAtPrice
                      className={'opacity-50 pl-20'}
                      data={compareAtPrice as MoneyV2}
                    />
                  )}
                </span>
              </div>
            ) : null}
          </div>
        </div>
      </Link>
      {/* {quickAdd && (
        <div className="single-products">
          <div className="products-content mt-0">
            <AddToCartButton
              lines={[
                {
                  quantity: 1,
                  merchandiseId: firstVariant.id,
                },
              ]}
              variant="secondary"
              className="add-to-cart-btn"
              analytics={{
                products: [productAnalytics],
                totalValue: parseFloat(productAnalytics.price),
              }}
            >
              <Text
                as="span"
                className="flex items-center justify-center gap-2"
              >
                Add to Bag
              </Text>
            </AddToCartButton>
          </div>
        </div>
      )} */}
    </div>
  );
}

function CompareAtPrice({
  data,
  className,
}: {
  data: MoneyV2;
  className?: string;
}) {
  const {currencyNarrowSymbol, withoutTrailingZerosAndCurrency} =
    useMoney(data);

  const styles = clsx('strike', className);

  return (
    <span className={styles}>
      {currencyNarrowSymbol}
      {withoutTrailingZerosAndCurrency}
    </span>
  );
}
